import { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * Public short-link redirect page.
 *
 * SMS / email recipients hit URLs like https://simplyfunded.au/r/abc123
 * and we forward them to the backend redirect endpoint which 302s to the
 * real GoCardless authorisation URL.
 *
 * Doing this on the frontend keeps the customer-facing URL short and clean
 * (no /api/ prefix) without any DNS changes.
 */
export default function ShortLinkRedirect() {
  const { code } = useParams();

  useEffect(() => {
    if (!code) return;
    // Hard navigation so the 302 from the backend is followed by the browser
    window.location.replace(`/api/r/${code}`);
  }, [code]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center space-y-3">
        <div className="w-10 h-10 mx-auto border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-700 font-medium">Redirecting to GoCardless…</p>
        <p className="text-xs text-slate-500">Please wait while we open your secure authorisation page.</p>
      </div>
    </div>
  );
}
